import HeroBanner from "../components/HeroBanner";
import CategoryGrid from "../components/CategoryGrid";
import FeaturedProducts from "../components/FeaturedProducts";
import ProductSearch from "../components/ProductSearch";
import { SEOHead } from "@/components/SEOHead";
const Index = () => (
  <>
    <SEOHead
      title="Bahama Marketplace - Your Local Marketplace"
      description="Discover amazing products from local sellers across the Bahamas. Shop unique items, support local businesses, and find great deals on Bahama Marketplace."
      keywords="Bahamas marketplace, Bahamian products, local vendors, handcrafted jewelry, Nassau shopping, Caribbean marketplace"
    />
    <main className="min-h-screen bg-background">
      <HeroBanner>
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight">
          Welcome to{" "}
          <span className="text-primary bg-gradient-to-r from-primary to-primary/80 bg-clip-text text-transparent">
            Bahama Marketplace
          </span>
        </h1>
        <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
          Discover unique products from local sellers across the beautiful Bahamas. 
          Shop with confidence, support local businesses, and find amazing deals.
        </p>
      </HeroBanner>
      <div className="container mx-auto px-4 space-y-24 py-16">
        <CategoryGrid />
        <ProductSearch />
        <FeaturedProducts />
      </div>
    </main>
  </>
);

export default Index;